<template>
  <v-container fluid>
    <material-card
      icon="mdi-clipboard-text"
      inline
      title="View Student General Diary"
    >
      <v-card-actions>
        <router-link :to="{ name: 'viewStudentGeneralDiary' }">
          <v-btn
            v-if="$vuetify.breakpoint.smAndUp"
            elevation="1"
            absolute
            top
            right
          >
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn
            v-else
            fixed
            right
            fab
            small
            color="grey lighten-2"
            elevation="1"
            class="mr-n2 mt-10"
            style="opacity: 0.6"
          >
            <v-icon>mdi-arrow-left</v-icon></v-btn
          >
        </router-link>
      </v-card-actions>
      <v-card flat class="px-2">
        <form>
          <v-row>
            <v-col cols="12" md="4">
              <label class="font-weight-medium body-2"> Title</label>
              <v-text-field
                class="my-0 py-1"
                readonly
                v-model="title"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="8">
              <label class="font-weight-medium body-2"> General Remark </label>
              <!-- <ckeditor read-only v-model="GeneralRemark" ref="ckeditorRef"></ckeditor> -->
              <!-- <textarea readonly class="input" rows="3" v-model="GeneralRemark" ref="ckeditorRef"></textarea> -->
              <quill-editor
                :disabled="true"
                :options="options"
                v-model="GeneralRemark"
                theme="snow"
                ref="myQuillEditor"
              >
              </quill-editor>
            </v-col>
            <v-col cols="12" md="12" v-if="dropFile1.length > 0">
              <label class="warning--text"> Uploaded Documents</label>
              <div>
                <v-chip
                  class="mr-2 mt-2"
                  color="primary"
                  label
                  outlined
                  v-for="(file, i) in dropFile1"
                  :key="i"
                  @click="download(file.urlPath)"
                >
                  {{ file.name }}
                </v-chip>
              </div>
            </v-col>
          </v-row>
        </form>
      </v-card>
    </material-card>
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
// import Utils from '@/utils'
// import Vue from 'vue'
// import CKEditor from 'ckeditor4-vue'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
// Vue.use(CKEditor)
export default {
  name: 'showStudentGeneralDiary',
  props: ['generalDiaryID'],
  components: { MaterialCard, quillEditor },
  data () {
    return {
      total: 0,
      dropFile: [],
      discription: '',
      type: '',
      title: '',
      typeData: [],
      GeneralRemark: '',
      generalDiary: [],
      documentData: [],
      hasClicked: false,
      loader: true,
      sendData: {},
      selectedfranchiseeID: [],
      dropFile1: [],
      options: {
        debug: 'info',
        modules: {
          toolbar: []
        },
        readOnly: true,
        theme: 'snow'
      }
    }
  },

  async created () {
    await this.studentGeneralDiary()
    await this.studentGeneralDiaryDocuments()
  },
  beforeRouteLeave (to, from, next) {
    // Ckeditor maximize fix
    // const that = this.$refs.ckeditorRef
    // const maximizedState = that.instance.getCommand('maximize').state
    // if (maximizedState === 1) {
    //   that.instance.execCommand('maximize')
    // }
    next()
  },
  methods: {
    studentGeneralDiary: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/communication/studentGeneralDairy/${this.generalDiaryID}`
        )
        this.generalDiary = data
        this.title = this.generalDiary.title
        this.GeneralRemark = this.generalDiary.generalRemark
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    studentGeneralDiaryDocuments: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/communication/studentGeneralDairy/${this.generalDiaryID}`
        )
        this.documentData = data
        this.dropFile1 = this.documentData.studentGeneralDairyDocuments
        if (this.dropFile1) {
          this.dropFile1.forEach((docID) => {
            docID.name = docID.urlKey.substring(
              docID.urlKey.lastIndexOf('/') + 1
            )
          })
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },

    download: async function (i) {
      try {
        let url = await http.get(
          `${constants.API_URL}/api/staff/downloadurl?s3urlKey=${i}`
        )
        window.open(url.data)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    }
  }
}
</script>
<style scoped>
textarea {
  background-color: #ffffff;
  border-color: #dbdbdb;
  border-radius: 4px;
  color: #363636;
  height: 9.5rem;
}
</style>
